import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Form, Input, Label, FormGroup, FormText, Button } from 'reactstrap';
import { connect } from 'react-redux';

class BeaconConn extends Component {
    static displayName = BeaconConn.name;
    //This page manages manual Beacon connections
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            permissionFlag: true,
            connectionData: [],
            studentName: "",
            instName: "",
            hideExpDate: false,
            textboxOn: false,
            textboxPK: "",
            textboxPkList: [],//I'm rather proud of this. This state array lists the Beacon connection values that need to have their edit windows open. Clicking on the show button toggles
                                //whether the connection's PK is displayed here.
            groupSelect: [],
            stuPCID: "",
            groupID: "DEFAULT",
            instPCID: "",
            expDate: "",
        }
        this.testPermission();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            level: this.props.ourLevel
        });
        var dept = this.props.reduxData.userInfo.level.pk
        //this.recordComingHere();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1028",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1028"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
        this.getBeaconData();
        this.getGroupData();
    }

    async getBeaconData() {//To retrieve the full list of manual Beacon connections that already exist
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('GetManualConn', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            connectionData: data
        })
    }

    async getGroupData() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk 
        }
        const response = await fetch('GetBeaconGroups', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            groupSelect: data
        })
    }

    componentDidMount() {

    }

    async newConnection(e) {
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        //localStorage.setItem("lastFetch", moment());
        if (this.state.expDate == "" && this.state.hideExpDate == false) { //We allow for the user to input a new connection without an expiration date, but they have to specify it. If they didn't,
                                                                            //we reject the new add
            return;
        }
        if (this.state.instPCID == "") {//All of these conditions could be consolidated into one if statement, however this is a change that should be done in its own branch for testing
            return;
        }
        if (this.state.stuPCID == "" && this.state.groupID == "DEFAULT") {
            return;
        }
        if (this.state.stuPCID != "" && this.state.groupID != "DEFAULT") {
            return;
        }
        if (this.state.hideExpDate == true) {//todo: look into consolidating this into an if statement to govern an expDate variable and have toSend.expDate use that variable
            let targetConn
            if (this.state.stuPCID != "") { targetConn = this.state.stuPCID } else { targetConn = this.state.groupID }
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                student: targetConn,
                instructor: this.state.instPCID,
                expDate: "null"
            }
            const response = await fetch('AddConn', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.getBeaconData();
        }
        else if (this.state.hideExpDate == false) {
            let targetConn
            if (this.state.stuPCID != "") { targetConn = this.state.stuPCID } else { targetConn = this.state.groupID }
            let toSend = {
                userLevel: this.props.reduxData.userInfo.level.pk,
                student: targetConn,
                instructor: this.state.instPCID,
                expDate: this.state.expDate
            }
            const response = await fetch('AddConn', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.getBeaconData();
        }
        else return;
    }

    async nameLookup(e) {//This is like the fifth time I've used this exact same nameLookup process
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        this.setState({
            stuPCID: e.target.value,
            groupID: "DEFAULT"
        })
        if (e.target.value.length == 10) { 
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            const response = await fetch('stuLookupBeacon', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                studentName: data.stuName
            });
        } else {
            this.setState({
                studentName: ""
            })
        }
        //localStorage.setItem("lastFetch", moment());
    }

    async nameLookupInstr(e) {//This is actually the exact same procedure as this.nameLookup() except it puts the returned values in this.state.instName
                                //todo: consolidate into this.nameLookup()?
        this.setState({
            instPCID: e.target.value
        })
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        if (e.target.value.length == 10) {
            let toSend = {
                stuPCID: e.target.value,
                userLevel: this.props.reduxData.userInfo.level.pk
            }
            const response = await fetch('stuLookupBeacon', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
                body: JSON.stringify(toSend)
            });
            const data = await response.json();
            this.setState({
                instName: data.stuName
            });
        } else {
            this.setState({
                instName: ""
            })
        }
        //localStorage.setItem("lastFetch", moment());
    }

    noExpSwitch() {//When the user indicates they want to add a connection without an expiration date, this function toggles the state value that stores that information.
                    //The checkbox is in the form so it'll be picked up in the submit event, but this is needed to hide the ability to add an expiration date
                    //After all, the user said they aren't going to be adding one, right?
        this.setState({
            hideExpDate: !this.state.hideExpDate
        })
    }

    textboxOn(pk) {//The name of this function may be a little misleading, this isn't just for turning the textbox on but is for whenever the textbox needs to be switched on or off
        if (this.state.textboxPkList.indexOf(pk) <= -1) {//When the textbox isn't already on, we need to say this.state.textboxPkList is equal to the prior list and add the new PK
            this.setState(prevState => ({
                textboxPkList: [...prevState.textboxPkList, pk]
            }))
        }
        else {//textboxPkList is a list of active textboxes and we can't just add or remove them from the list in state directly
                //I mean, we probably could, but you should never actually do that.
            let currList = this.state.textboxPkList
            let index = currList.indexOf(pk)
            currList.splice(index, 1);
            this.setState({
                textboxPkList: currList
            })
        }
    }

    async updateExpDate(pk, operation, e) {//The operation param isn't really necessary because the only time this function is called is when the expiration date needs to be updated.
                                            //However, because the source of the new date is different (one being an actual date and one being a predefined "yesterday") we likely 
                                            //need to keep them separated
        e.preventDefault();
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const dataInput = new FormData(e.target);
        this.textboxOn(pk);//Once the user indicates they want to save changes, the textbox should go away
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            target: pk,
            newdate: dataInput.get('inputdate'),
            operation: operation
        }
        const response = await fetch('UpdateConnExp', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.getBeaconData();
    }

    async deleteConn(pk, operator) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            target: pk,
            newdate: "delete",
            operation: operator
        }
        const response = await fetch('UpdateConnExp', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.getBeaconData();
    }

    selectGroup(e) {
        this.setState({
            stuPCID: "",
            studentName: "",
            groupID: e.target.value
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form className="d-flex" onSubmit={this.newConnection.bind(this)} id="connForm">
                                <FormGroup>
                                    <Label>Student&emsp;&emsp;&emsp;<b>or</b></Label>
                                    <Input onChange={(e) => this.nameLookup(e)} type="text" name="stuPCID" id="stuPCID" bsSize="sm" value={this.state.stuPCID} />
                                    <FormText>{this.state.studentName.stuName}</FormText>
                                </FormGroup>
                                &nbsp;
                                <FormGroup>
                                    <Label>Group</Label>
                                    <Input type="select" name="groupID" id="groupID" bsSize="sm" defaultValue="DEFAULT" onChange={(e) => this.selectGroup(e)} value={this.state.groupID }>
                                        <option value="DEFAULT" disabled>Select</option>
                                        {this.state.groupSelect.map(item => (
                                            <option value={item.code}>{item.name}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                &emsp;
                                <FormGroup>
                                    <Label>Instructor</Label>
                                    <Input onChange={this.nameLookupInstr.bind(this)} type="text" name="instPCID" id="instPCID" bsSize="sm" value={this.state.instPCID} />
                                    <FormText>{this.state.instName}</FormText>
                                </FormGroup>
                                &emsp;
                                <FormGroup hidden={this.state.hideExpDate}>
                                    <Label>Expiration Date</Label>
                                    <Input type="date" name="expDate" id="expDate" value={this.state.expDate} onChange={(e) => this.setState({expDate: e.target.value}) } />
                                </FormGroup>
                                &emsp;&emsp;
                                <FormGroup>
                                    <Label>No Expiration Date?</Label><br />
                                    <Input type="checkbox" name="noExp" id="noExp" onClick={this.noExpSwitch.bind(this) }/>
                                </FormGroup>
                                &emsp;&emsp;
                                <Button type="submit" outline color='success'>Add</Button>
                            </Form>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Student or Group</th>
                                        <th>Advisor</th>
                                        <th>Expiration (if exists)</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.connectionData.map(data => (
                                        <tr>
                                            <th>{data.pk}</th>
                                            <td>{data.student}</td>
                                            <td>{data.instructor}</td>
                                            <td><div style={{ visibility: this.state.textboxPkList.indexOf(data.pk) <= -1 ? 'visible' : 'hidden' }}> {data.expdate}</div>
                                                <div style={{ visibility: this.state.textboxPkList.indexOf(data.pk) > -1 ? 'visible' : 'hidden' }}>
                                                    <Form className='d-flex' onSubmit={(e) => this.updateExpDate(data.pk, "update", e) }>
                                                        <Input type="date" placeholder={data.expdate} name="inputdate" id="inputdate" />&nbsp;
                                                        <Button type="submit" outline color='success'>Post</Button>
                                                    </Form>
                                                </div></td>
                                            <td><Button outline color="warning" onClick={(e) => this.textboxOn(data.pk)} >
                                                {this.state.textboxPkList.indexOf(data.pk) > -1 ? 'Hide' : 'Edit' }
                                            </Button>
                                                &nbsp;
                                                <Button outline color="danger" onClick={() => this.deleteConn(data.pk, "delete") }>
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}
                </UserContext.Consumer>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(BeaconConn);